<template>
	<router-link
		:to="$store.getters['main/getSingleUrl'](data)"
		class="story-card"
		style="width: 100%;"
	>
		<div class="img-box">
			<picture>
				<source
					class="img-absolute scale"
					media="(max-width: 767px)"
					:srcset="_.get(data, 'images[0].devices.mobile')"
				/>
				<source
					class="img-absolute scale"
					media="(max-width: 1023px)"
					:srcset="_.get(data, 'images[0].devices.tablet')"
				/>
				<img
					class="img-absolute scale"
					:src="_.get(data, 'images[0].devices.desktop')"
					:alt="_.get(data, 'images[0].title.title')"
				/>
			</picture>
		</div>
		<div class="story-info">
			<span class="font-13 date" :class="_.get(getCategoryName, '[0]') ? 'has-category' : ''">{{
				date
			}}</span>
			<!-- getCategoryName || $fn.tr("no story") -->
			<template v-for="(item, index) in getCategoryName">
				<span class="font-13 category" :key="index">{{ item.title || $fn.tr('no story') }}</span>
			</template>
		</div>
		<h3 class="font-21 text-overflow-hidden-2">{{ _.get(data, 'title') }}</h3>
		<div
			class="text text-overflow-hidden-2"
			v-html="_.get(data, 'teaser')"
			v-if="content && _.get(data, 'teaser')"
		></div>
	</router-link>
</template>
<script>
import moment from 'moment';

export default {
	props: ['data', 'filterData', 'content'],

	computed: {
		date() {
			return moment(this.data?.date).format('D MMM, YYYY');
		},
		getCategoryName() {
			let allTags = _.get(this.$store.state.main.indx, 'terms.stories_category');
			let data = this.data?.stories_category;
			let getName = allTags.filter((item) => data?.includes(item.id));

			return getName;
		},
	},
};
</script>
<style lang="scss">
.story-card {
	.text {
		margin-top: 20px;
		img {
			display: none;
		}
	}
	&:hover {
		.img-box {
			img {
				transform: scale(1.1);
			}
		}
		h3 {
			color: var(--primary-txt);
			text-decoration-color: var(--primary-txt);
		}
	}
	.img-box {
		width: 100%;
		position: relative;
		height: 233px;
		margin-bottom: 18px;
		overflow: hidden;
		@media (max-width: 1439px) {
			height: auto;
			padding-top: 70%;
		}
		@media (max-width: 767px) {
			margin-bottom: 13px;
		}
		.img-absolute {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
			will-change: transform;
		}
	}
	.story-info {
		margin-bottom: 29px;
		@media (max-width: 767px) {
			margin-bottom: 21px;
		}
		.date {
			color: var(--red);
			&.has-category {
				padding-right: 5px;
				margin-right: 5px;
				border-right: 1px solid var(--bonus-txt);
			}
		}
		.category {
			color: var(--bonus-txt);
			text-decoration: underline;
			text-decoration-color: var(--bonus-txt);
			margin-right: 5px;
		}
	}
	h3 {
		color: var(--bonus-txt);
		text-decoration: underline;
		text-decoration-color: var(--bonus-txt);
	}
}
</style>
